import React, { Component, useCallback, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";
import { color } from "../../../../../mui-theme/palette";
import { useTranslation } from "react-i18next";
//PHKL Custom -s
import { commonSlice, CommonState } from "../../../../../redux/common/common-slice";
import { useSelector } from "react-redux";
import { GlobalHelper } from "../../../../../utils/helpers/global-helper";

const { sendOtpStartTimingAction } = commonSlice.actions;
//PHKL Custom -e

export const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: color.majorRed,
  backgroundColor: color.redLight,
  "&:hover": {
    backgroundColor: color.redLight,
  },
  padding: 0,
}));
export const ColorButton2 = styled(Button)<ButtonProps>(({ theme }) => ({
  color: color.blue,
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "transparent",
  },
  "&:disabled": {
    color: color.grey99,
  },
  padding: 0,
  fontSize: 12,
  fontWeight: 500,
}));

export type OtpButtonProps = ButtonProps;

const TIME = 120; //PHKL Custom
// const TIME = 1;

export const OtpButton = (props: OtpButtonProps) => {
  const sendOtpStartTiming = useSelector((state: { common: CommonState }) => state.common.sendOtpStartTiming) as any; //PHKL Custom
  const { t } = useTranslation();
  const [startTime, setStartTime] = useState<number | null>(null);
  const [remainingTime, setRemainingTime] = useState<number>(0);
  const [isFirstClick, setIsFirstClick] = useState<boolean>(true); //PHKL Custom

  useEffect(() => {
    if (!startTime) return;
    //PHKL Custom -s
    if (isFirstClick) {
      setIsFirstClick(false);
    }
    //PHKL Custom -e

    const timer = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const remaining = Math.max(0, TIME - elapsed);
      setRemainingTime(remaining);

      if (remaining <= 0) {
        setStartTime(null);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [startTime]);

  const startCooldown = () => {
    setStartTime(Date.now());
    setRemainingTime(TIME);
  };

  const isDisabled = remainingTime > 0;

  //PHKL Custom -s
  useEffect(() => {
    if (sendOtpStartTiming) {
      startCooldown();
      GlobalHelper.getGlobalDispatch()?.(sendOtpStartTimingAction(false));
    }
  }, [sendOtpStartTiming]);
  //PHKL Custom -e

  return (
    <ColorButton2
      {...props}
      disabled={isDisabled || props.disabled}
      onClick={(e) => {
        // startCooldown();//PHKL Custom
        props.onClick?.(e);
      }}
    >
      {/* PHKL Custom -s  */}
      {(isFirstClick
        ? t("Recruitment.onboarding_login_send_code")
        : t("Recruitment.onboarding_login_resend_code")) +
        (isDisabled ? ` (${remainingTime}s)` : "")}{" "}
      {/* PHKL Custom -e  */}
    </ColorButton2>
  );
};
